export default {
      baseUrl: '',
      vueUrl: '',
      apiFileBasePath: process.env.VUE_APP_BASE_URL,
      apiPortalFileBasePath: process.env.VUE_APP_BASE_URL +  '/portal',
      apiBasePath: process.env.VUE_APP_BASE_URL +  '/api/v1',
      apiPortalBasePath: process.env.VUE_APP_BASE_URL + '/api/v1/portal',
}
